import BaseBean from "@/model/BaseBean";
import BaseRequestBean from "@/model/BaseRequestBean";
import { onMounted, Ref, ref, ToRef, watch } from "vue";

type VoidFuntion = () => void;

interface useListDataReturn<T, M> {
  requestObj: ToRef<M>;
  dataList: Ref<T | undefined>;
  totalNum: Ref<number>;
  isRequesting: Ref<boolean>;
  prevClick: () => void;
  nextClick: () => void;
  getListData: () => void;
  handleCurrentChange: (page: number) => void;
  handleSizeChange: (size: number) => void;
  setResultFaultF: (func: VoidFuntion) => void;
  setNotWatchRequest: () => void;
}

export default function useListData<
  T extends BaseBean,
  M extends BaseRequestBean
>(requestFunc: (requestObj: M) => Promise<T>): useListDataReturn<T, M> {
  const requestInfo = new Object() as M;
  requestInfo.page = 1; //默认是第一页
  requestInfo.size = 20; //默认一次请求10条数据
  const totalNum = ref<number>(0);
  const requestObj = ref<any>(requestInfo);
  const dataList = ref<T>();
  const isRequesting = ref<boolean>(false);
  let resultFaultF: VoidFuntion;
  let needWatchRequest = true;

  let requestTimeOut: number;
  const getListData = () => {
    clearTimeout(requestTimeOut);
    requestTimeOut = setTimeout(() => {
      isRequesting.value = true;
      requestFunc(requestObj.value)
        .then((result: T) => {
          isRequesting.value = false;
          dataList.value = result;
          if (Object.prototype.hasOwnProperty.call(result, "totalNum")) {
            totalNum.value = Number(result.totalNum);
          } else {
            totalNum.value = Number(result.total_num);
          }
        })
        .catch(() => {
          isRequesting.value = false;
          if (resultFaultF) {
            resultFaultF();
          }
        });
    }, 50);
  };

  const setResultFaultF = (func: VoidFuntion) => {
    resultFaultF = func;
  };

  const setNotWatchRequest = () => {
    needWatchRequest = false;
  };

  const prevClick = () => {
    //
  };

  const nextClick = () => {
    //
  };

  const handleCurrentChange = (page: number) => {
    const obj = requestObj.value as BaseRequestBean;
    if (page > 0) {
      obj.page = page;
      requestObj.value = obj;
    }
  };

  const handleSizeChange = (size: number) => {
    const obj = requestObj.value as BaseRequestBean;
    obj.size = size;
    requestObj.value = obj;
  };

  watch(
    requestObj,
    () => {
      if (needWatchRequest) {
        getListData();
      }
    },
    {
      deep: true,
    }
  );

  onMounted(() => {
    getListData();
  });

  return {
    requestObj,
    dataList,
    totalNum,
    isRequesting,
    prevClick,
    nextClick,
    getListData,
    setResultFaultF,
    handleCurrentChange,
    setNotWatchRequest,
    handleSizeChange,
  };
}
